import { memo, useContext } from 'react';
import { Stack, CollapsibleGroup } from '@library';
import type { FooterSectionComponent } from '../../../content/types/types';
import { AppContext } from '../../context';
import FooterSection from './FooterSection';
import styles from './FooterSections.module.scss';

const FooterSections = ({
    sections,
}: {
    sections: FooterSectionComponent[];
}) => {
    const { isInMobileView } = useContext(AppContext);

    return (
        <Stack
            direction="responsiveColumnTabletRow"
            gap="responsiveNoneTabletLarge"
        >
            {isInMobileView ? (
                <div className={styles.collapsibleGroup}>
                    <CollapsibleGroup>
                        {sections.map(section => {
                            const { _uid: id } = section;
                            return <FooterSection key={id} section={section} />;
                        })}
                    </CollapsibleGroup>
                </div>
            ) : (
                sections.map(section => {
                    const { _uid: id } = section;
                    return <FooterSection key={id} section={section} />;
                })
            )}
        </Stack>
    );
};

export default memo(FooterSections);
